import { render } from "./LoyaltyManagement.vue?vue&type=template&id=7374ddda"
import script from "./LoyaltyManagement.vue?vue&type=script&lang=js"
export * from "./LoyaltyManagement.vue?vue&type=script&lang=js"

import "../assets/css/loyalty.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__